/**
 * Created by Rodrigo Quesada on 17/02/17.
 */
import {Routes, Route, ActivatedRoute, ActivatedRouteSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {NavigableNode, NavigableNodeDeps} from './navigable-node.class';
import {Step} from './step.class';
import {RouteConfig} from './sections.service';

export class Section extends NavigableNode<Section, Step> {

    TYPE = Section;
    CHILD_TYPE = Step;

    refreshed$: Observable<boolean>;

    get totalSteps(): number {
        return this._children.filter(value => value.authorized() && !value.isSkipped()).length;
    }

    get currentStepNumber(): number {
        return this._currentChild ? this._currentChild.stepNumber : 0;
    }

    get stepsProgress(): number {
        return (this.currentStepNumber) * 100 / this.totalSteps;
    }

    readonly title: string;

    constructor(navigableNodeDeps: NavigableNodeDeps, route: Route, steps: Step[]) {
        super(navigableNodeDeps, route, steps);
        this._setStepNumbers();
        this.title = route.data![RouteConfig.SECTION].title;

        this.refreshed$ = Observable.from(steps).map(it => it.refreshed$).combineAll().map(values => (values as Array<boolean>).every(it => it));
    }

    protected _setCurrentChild(child: Step|undefined, route: ActivatedRoute) {
        super._setCurrentChild(child, route);
    }

    private _setStepNumbers() {
        this._children.filter(value => value.authorized() && !value.isSkipped()).forEach((step, i) => step.stepNumber = i + 1);
    }

    refreshCurrentChild(route: ActivatedRoute) {
        this._setStepNumbers();
        super.refreshCurrentChild(route);
    }

    static fromRoutes(navigableNodeDeps: NavigableNodeDeps, routes: Routes): Observable<Section> {
        return Section._fromRoutes(navigableNodeDeps, Section, routes);
    }

    static _fromRoute(navigableNodeDeps: NavigableNodeDeps, route: Route): Observable<Section> {
        let sections$: Observable<Section>;

        if (Section._isAssociatedRoute(route)) {
            sections$ = Step.fromRoutes(navigableNodeDeps, route.children!)
                .toArray()
                .map(steps => new Section(navigableNodeDeps, route, steps));
        }
        else if (route.children) {
            sections$ = Observable.from(route.children).flatMap(child => Section._fromRoute(navigableNodeDeps, child));
        }
        else {
            sections$ = Observable.of();
        }

        return sections$;
    }

    static _findAssociatedRoute(route: ActivatedRoute): ActivatedRoute|undefined {
        while (!Section._isAssociatedRoute(route.snapshot) && route.firstChild) route = route.firstChild;
        if (Section._isAssociatedRoute(route.snapshot)) return route;
    }

    static _isAssociatedRoute(route: Route|ActivatedRouteSnapshot): boolean {
        return route.data && route.data[RouteConfig.SECTION];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/sections/service/section.class.ts